import type { getTranslations } from "next-intl/server";
import type { ReactNode } from "react";

import type { Plan } from "@trip/common";

import { type TourFromPage } from "../page";

export function getPlanChoices({
  datoPlans,
  plans,
  formatDate,
  t,
}: {
  datoPlans: TourFromPage["plans"];
  plans: Plan[];
  formatDate: (value: Date) => string;
  t: Awaited<ReturnType<typeof getTranslations>>;
}) {
  return plans.flatMap((plan) => {
    const datoPlan = datoPlans.find(
      (datoTourPlan) => datoTourPlan.planId === plan.id,
    );
    if (!plan.id || (datoPlan && datoPlan.hidden === true)) {
      return [];
    }
    let name: ReactNode = datoPlan?.title ?? plan.name;
    if (typeof plan.openDateExpiration === "object") {
      name = (
        <>
          <>{name}</>
          <br />
          <span className="text-xs font-normal text-neutral-500">
            {t("voucherExpires", { date: formatDate(plan.openDateExpiration) })}
          </span>
        </>
      );
    }
    return [{ id: plan.id, name }];
  });
}
